// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__WAkhk {
	/* display: flex; */
	width: 80%;
}

.styles_timeline__headerbar__Oy8Jz {
	font-size: 1.5rem;
	font-family: 'LibreBodoniBold';
	padding: 1rem 0;
	border-top: #e4e4e7 1px solid;
	border-bottom: #e4e4e7 1px solid;
	margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/timeline/styles.module.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,8BAA8B;CAC9B,eAAe;CACf,6BAA6B;CAC7B,gCAAgC;CAChC,qBAAqB;AACtB","sourcesContent":[".container {\r\n\t/* display: flex; */\r\n\twidth: 80%;\r\n}\r\n\r\n.timeline__headerbar {\r\n\tfont-size: 1.5rem;\r\n\tfont-family: 'LibreBodoniBold';\r\n\tpadding: 1rem 0;\r\n\tborder-top: #e4e4e7 1px solid;\r\n\tborder-bottom: #e4e4e7 1px solid;\r\n\tmargin-bottom: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__WAkhk`,
	"timeline__headerbar": `styles_timeline__headerbar__Oy8Jz`
};
export default ___CSS_LOADER_EXPORT___;
